import React from 'react'
import { useParams } from 'react-router-dom'
import { useImportPins } from './ImportPins.hook'
import { QuizQuestionWrapper } from '../../components'
import { LoadingSpinner } from 'src/common/components/loading/LoadingSpinner'
import { CheckboxButton } from 'src/common/components'
import { CheckCircleIcon } from 'src/common/icons'
import '../style.scss'
import { QuizType } from 'src/pages/shared'

export const ImportPins = () => {
  const { boardId } = useParams<{ boardId: string }>()
  const {
    loading,
    canImport,
    isSelectedAll,
    boardDetail,
    selectedSection,
    filteredPins,
    handleNext,
    handleBack,
    handleImportPinsFromBoard,
    handleSelectPin,
    handleSelectAllPins,
    toggleSelectSection,
  } = useImportPins(boardId)

  return (
    <>
      <QuizQuestionWrapper
        titleStep="Getting Started"
        backAction={{
          onAction: handleBack,
        }}
        nextAction={{
          onAction: handleNext,
        }}
        step={2}
        total={7}
        className="pinterest-flow import-pins"
        quizType={QuizType.PINTEREST}
      >
        {/* <div className="import-pins-content"> */}
        <div className="custom-header">
          <div className="title">Import pins for inspiration</div>
          <div className="import-btn">
            <button className="button" onClick={handleImportPinsFromBoard} disabled={!canImport}>
              IMPORT SELECTED
            </button>
          </div>
        </div>
        <div className="select-all-pins">
          <CheckboxButton id="selectAllPins" value="selectAllPins" onChange={handleSelectAllPins}>
            {isSelectedAll ? 'Deselect all' : 'Select all'}
          </CheckboxButton>
        </div>
        <div className="board-details">
          {!loading ? (
            <>
              <div className="list-sections">
                {boardDetail?.sections.map((section) => (
                  <div
                    key={section.id}
                    className={`section-item ${section.id === selectedSection?.id ? 'active' : ''}`}
                    onClick={() => toggleSelectSection(section)}
                  >
                    <div className="section-images">
                      {section.coverImageUrls.slice(0, 3).map((url, index) => (
                        <div key={index} className="image">
                          <img src={url} alt={section.name} />
                        </div>
                      ))}
                    </div>
                    <div className="board-info">
                      <div className="board-title">{section.name}</div>
                      <div className="board-pin-count">{section.pinCount} pins</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="list-pins">
                {filteredPins.map((pin) => (
                  <div
                    key={pin.id}
                    className={`pin-item ${pin.isSelected ? 'selected' : ''}`}
                    onClick={() => handleSelectPin(pin)}
                  >
                    <img src={pin.imageUrl} alt={pin.title} loading="lazy" />
                    <CheckCircleIcon className="selected-icon" />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="loading-container">
              <LoadingSpinner size="sm" />
            </div>
          )}
        </div>
        {/* </div> */}
      </QuizQuestionWrapper>
    </>
  )
}
